












import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import StringUtils from '@/helpers/stringUtils';
import moment from 'moment';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages
  }
})
export default class AdmsVisitorsDailyCharts extends BaseComponent {
  @Prop()
  admKpis: any[];

  @Prop({ default: 'TT' })
  tpAtvInt: string;

  @Prop()
  keyValue: number;

  chartData: any[] = [];

  chartOptions = {};

  buldChartOptions() {
    this.chartOptions = {
      legend: {
        position: 'bottom'
      },
      height: 250,
      chartArea: { left: '60', top: '20', right: '20', bottom: '100' },
      fontSize: 12,
      hAxis: {
        slantedText: true,
        slantedTextAngle: 45
      },
      vAxis: {
        title: 'Horas',
        minValue: 0,
        titleTextStyle: {
          italic: false
        }
      }
    };
  }

  mounted() {
    this.buldChartOptions();
    this.load();
  }

  load() {
    this.chartData = [];
    let map = new Map();
    let dates = new Set<string>();
    let names = new Set<string>();
    this.admKpis.forEach((i) => {
      if (!map[i.data]) {
        map[i.data] = [];
      }
      if (!map[i.data][i.nome]) {
        map[i.data][i.nome] = [];
      }
      map[i.data][i.nome] =
        Math.ceil(
          ((this.tpAtvInt == 'TT'
            ? i.tempoTotalMinutos
            : this.tpAtvInt == 'AT'
            ? i.tempoAtivMinutos
            : i.tempoAfastMinutos) /
            60) *
            10
        ) / 10;
      dates.add(i.data);
      names.add(i.nome);
    });

    let headers = ['Data'];
    names.forEach((n) => headers.push(StringUtils.abbreviate(n, 20)));
    this.chartData.push(headers);
    dates.forEach((d) => {
      let day = [];
      day.push(moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY'));
      names.forEach((n) => {
        let v = map[d][n];
        if (!v) {
          v = 0;
        }
        day.push(v);
      });
      this.chartData.push(day);
    });
  }

  @Watch('admKpis', { immediate: true })
  @Watch('tpAtvInt', { immediate: true })
  kpisWatch(v) {
    if (!v) {
      return;
    }
    this.load();
  }
}
